import React from 'react'
import { Accordion } from 'react-bootstrap'

const Feature2 = () => {
    return (
        <>
            <Accordion>
                {
                    [1, 2, 3, 4, 5, 6].map(item => (
                        <Accordion.Item eventKey={item} key={item}>
                            <Accordion.Header>Is this a Sample Heading? 2</Accordion.Header>
                            <Accordion.Body>
                                Lorem ipsum dolor sit amet consectetur. Et at cursus morbi et diam nibh diam nam pellentesque. Nunc quam venenatis metus augue tristique ornare. Eget tortor non nulla nunc orci facilisi lorem porta. Integer mattis ut nunc tempor vitae egestas.
                            </Accordion.Body>
                        </Accordion.Item>
                    ))
                }
            </Accordion>
        </>
    )
}

export default Feature2
